
namespace RioERP.Reports {
    export class OrderShippingColumns {
        static columnsKey = 'Reports.OrderShipping';
    }
}